import api from '../api';

export const allQueries = async (page) => {
    
        const res = await api.get(`/query/getAllQueries${page ? '?page=' + page : ''}`);
        console.log(res.data.allQueries);
        return res.data;
   
}

export const sendQueryResponse = async (queryId, response) => {
    
        const res = await api.patch(`/query/updateQuery/${queryId}`, {response : response});
        return res.data.updatedQuery;
}

export const sendMoneyToShoveller = async (id, jobId, queryId, payment) => {
    
        const res = await api.post(`/query/sendPaymentToShoveller`, {id,jobId,queryId,payment});
        return res.data;
}